import React from 'react';
import Modal from 'react-modal';

export default function ReactModal({ className, modalState, children, onClose = () => {} }) {
    return (
        <Modal
            overlayClassName="react-modal-overlay"
            className={`react-modal ${className ? className : ''}`}
            isOpen={modalState}
            ariaHideApp={false}
            onRequestClose={onClose}
        >
            {children}
        </Modal>
    );
}
